import type { SmartViewArtifact } from "../../../../../api/types/smartViewArtifactsTypes";

export const getArtifactViewUrl = (artifact: Pick<SmartViewArtifact, "id">): string => `./${artifact.id}/view`;

export const getArtifactEditUrl = (artifact: Pick<SmartViewArtifact, "id">): string => `./${artifact.id}/edit`;
